import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-triangle",
  "use": "icon-triangle-usage",
  "viewBox": "0 0 7 7.6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 7 7.6\" id=\"icon-triangle\">\n<style type=\"text/css\">\n\t#icon-triangle .st0{fill:currentColor}\n</style>\n<polygon class=\"st0\" points=\"0,3.8 7,7.6 7,3.8 7,0 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol